import React, { useEffect } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useFormik } from "formik";
import red_cross from "../../../../Assets/svg/red-cross.svg";
import { post, put } from "../../../../helpers/api_helper";
import { faqSchema } from "../../../../helpers/yup_validator";
import toast from "react-hot-toast";

const AddUpdateContentPopup = ({
  showModal,
  setShowModal,
  handleRefresh,
  mode,
  faqData,
  resetFormOnClose,
}) => {
  const formik = useFormik({
    initialValues: {
      question: "",
      answer: "",
    },
    validationSchema: faqSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        if (mode === "create") {
          await post("/faq", { ...values, status: "active" });
          toast.success("FAQ created successfully");
        } else if (mode === "edit") {
          await put(`/faq/${faqData._id}`, { ...values, status: "active" });
          toast.success("FAQ updated successfully");
        }
        setShowModal(false);
        handleRefresh();
      } catch (error) {
        console.error("Error submitting FAQ:", error);
        setErrors({
          submissionError: error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred.",
        });
        toast.error(
          error.response?.data?.message
            ? error.response?.data?.message
            : error.response?.data?.error || "An error occurred."
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (mode === "edit" && faqData) {
      formik.setValues({
        question: faqData.question,
        answer: faqData.answer,
      });
    } else if (resetFormOnClose) {
      formik.resetForm();
    }
  }, [mode, faqData, resetFormOnClose]);

  return (
    <>
      <Modal
        show={showModal}
        size="md"
        onHide={() => setShowModal(false)}
        backdrop="static"
        keyboard={false}
        centered
        scrollable="true"
        className="addUpdateContent"
      >
        <Modal.Body>
          <div className="topHeader d-flex align-items-start justify-content-between gap-10 pb-2">
            <div className="left">
              <h5 className="m-0 fw-sbold">
                {mode === "create" ? "Add FAQ" : "Edit FAQ"}
              </h5>
            </div>
            <Button
              className="p-0 border-0"
              variant="transparent"
              onClick={() => setShowModal(false)}
            >
              <img src={red_cross} alt="" />
            </Button>
          </div>
          <div className="FormWrapper">
            <Form onSubmit={formik.handleSubmit}>
              <Row>
                <Col lg="12" className="my-3">
                  <div className="position-relative labelInput">
                    <input
                      type="text"
                      className={`form-control ${
                        formik.touched.question && formik.errors.question
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Question Title"
                      name="question"
                      value={formik.values.question}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="question"
                      className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                    >
                      Question Title
                    </label>
                    {formik.touched.question && formik.errors.question ? (
                      <div className="invalid-feedback">
                        {formik.errors.question}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg="12" className="my-3">
                  <div className="position-relative labelInput">
                    <textarea
                      rows="4"
                      className={`form-control ${
                        formik.touched.answer && formik.errors.answer
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Answer"
                      name="answer"
                      value={formik.values.answer}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    ></textarea>
                    <label
                      htmlFor="answer"
                      className="form-label position-absolute d-inline-block bg-white m-0 px-1"
                    >
                      Answer
                    </label>
                    {formik.touched.answer && formik.errors.answer ? (
                      <div className="invalid-feedback">
                        {formik.errors.answer}
                      </div>
                    ) : null}
                  </div>
                </Col>
                <Col lg="12" className="my-2">
                  <div className="text-end">
                    <Button
                      type="submit"
                      className="d-inline-flex align-items-center justify-content-center commonBtn bordredBtn"
                      disabled={formik.isSubmitting}
                    >
                      {mode === "create" ? "Add FAQ" : "Update FAQ"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddUpdateContentPopup;
